import React, { useState } from 'react';

// components
import IconButton from 'components/IconButton';
import ClassroomLinksModal from 'layout/ApplicationLayout/components/ClassroomLinksButton/ClassroomLinksModal';

// icons
import FireplaceIcon from '@material-ui/icons/Fireplace';

export default function ClassroomLinksButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <IconButton
        id='classroomLinksButton'
        aria-label='Classroom Links Button'
        onClick={handleToggleModal}
      >
        <FireplaceIcon />
      </IconButton>
      <ClassroomLinksModal open={isModalOpen} onClose={handleToggleModal} />
    </>
  );
}
